<template>
    <section>
        <h3 class="text-uppercase mt-4">Invoices</h3>
        <hr class="bar my-3" />

        <table class="table bg-white">
            <thead>
                <tr>
                    <th scope="col">Ref. #</th>
                    <th scope="col">Date</th>
                    <th scope="col">Amount</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="invoice in invoices">
                    <th scope="row">{{ invoice.number }}</th>
                    <td>{{ invoice.date }}</td>
                    <td>${{ (invoice.total / 100).toFixed(2) }}</td>
                    <td>
                        <button
                            class="btn btn-sm btn-dark"
                            @click.prevent="downloadInvoice(invoice)"
                        >
                            Download
                        </button>
                    </td>
                </tr>
                <tr v-if="!invoices.length">
                    <td colspan="4" class="text-center font-italic">No invoices available.</td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
export default {
    name: "AccountInvoices",
    props: ["user", "subscription"],
    data() {
        return {
            invoices: [],
        };
    },
    mounted() {
        if (this.subscription && this.subscription.is_subscribed) {
            this.getInvoices();
        }
    },
    methods: {
        getInvoices() {
            axios
                .get(`/api/users/${this.user.id}/subscription/invoices`)
                .then(r => {
                    this.invoices = r.data.data;
                })
                .catch(e => {
                    console.error(e);
                });
        },

        downloadInvoice(invoice) {
            axios({
                url: `/api/users/${this.user.id}/subscription/invoice/${invoice.id}`,
                method: "GET",
                responseType: "blob",
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `GoLotus_Invoice_${invoice.number}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.loading = false;
                    console.error(e);
                });
        },
    },
};
</script>

<style scoped></style>
